/**
 * Maps API inline styles and text-format overrides to data-* attributes on table cells.
 * Used by TableTd/Th so exportWithStyles can read styling from the DOM.
 */
export function apiStylesParser(styleStr, textFormatOverrideStyles) {
  const { italic, bold, underline, strikethrough } =
    textFormatOverrideStyles ?? {};

  const styles = String(styleStr || "")
    .split(";")
    .map((s) => {
      const [prop, value] = s.split(":").map((x) => x.trim());
      return prop === "background" ? `background-color:${value}` : s;
    });

  return styles.reduce(
    (acc, curr) => {
      const [type, value] = curr.split(":").map((s) => s.trim());

      switch (type) {
        case "font-weight":
          acc["data-f-bold"] = true;
          break;
        case "font-style":
          acc["data-f-italic"] = true;
          break;
        case "padding-left":
          acc["data-a-indent"] = parseInt(value) / 10;
          break;
        case "background-color":
          acc["data-fill-color"] =
            "FF" +
            value.replaceAll("#", "").replaceAll("!important", "").trim();
          break;
        case "color":
          acc["data-color"] = value
            .replaceAll("#", "")
            .replaceAll("!important", "")
            .trim();
          break;
        default:
          break;
      }

      return acc;
    },
    {
      ...(italic && { "data-f-italic": true }),
      ...(bold && { "data-f-bold": true }),
      ...(underline && { "data-a-underline": true }),
      ...(strikethrough && { "data-a-strikethrough": true }),
    }
  );
}
